import styles from './ChatAnswer.module.scss';
import ChatMarkdown from './ChatMarkdown';
import { useAutoScroll } from './hooks';

export const CHAT_ANSWER_ELEMENT_ID = 'chatAnswer';

interface ChatAnswerProps {
  currentAnswer: string;
  questionId: string;
}

const ChatAnswer: React.FC<ChatAnswerProps> = ({
  currentAnswer,
  questionId,
}) => {
  // Use the auto-scroll hook instead of managing all the state directly
  const {
    ref: chatAnswerRef,
    height: chatAnswerHeight,
    handleScroll,
  } = useAutoScroll(currentAnswer, {
    maxHeight: 8 * 44,
    bottomBuffer: 30,
  });

  return (
    <div className={styles.chatAnswerContainer}>
      <div
        className={styles.chatAnswer}
        id={CHAT_ANSWER_ELEMENT_ID}
        ref={chatAnswerRef}
        style={{ height: chatAnswerHeight }}
        onScroll={handleScroll}
        tabIndex={-1}
      >
        <ChatMarkdown body={currentAnswer} />
      </div>
    </div>
  );
};

ChatAnswer.displayName = 'ChatAnswer';
export default ChatAnswer;
